import { render, staticRenderFns } from "./FranqueadorAprovado.vue?vue&type=template&id=275ba947&scoped=true"
import script from "./FranqueadorAprovado.vue?vue&type=script&lang=js"
export * from "./FranqueadorAprovado.vue?vue&type=script&lang=js"
import style0 from "./FranqueadorAprovado.vue?vue&type=style&index=0&id=275ba947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ba947",
  null
  
)

export default component.exports